/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useLogSwapAdminActionsWithSupabase() {
  return usePostHogFlag("log_swap_admin_actions_with_supabase");
}
